import React from "react";
import PhotoCell from "../../../components/const/Photo/PhotoCell";

export default function MobilePhotoBoardReadonly({ board }) {
    if (!board) return null;

    const gridX = board.grid_x || 2;
    const gridY = board.grid_y || 2;
    const items = board.photos || [];

    // 그리드 셀 생성 (빈 셀 포함)
    const totalCells = gridX * gridY;
    const cells = Array.from({ length: totalCells }, (_, i) => ({
        id: `cell-${i}`,
        photo: items[i] || null,
    }));

    return (
        <div className="w-full">
            <div
                className="grid gap-[2px] bg-gray-200 border border-gray-200 rounded-lg overflow-hidden"
                style={{
                    gridTemplateColumns: `repeat(${gridX}, 1fr)`,
                    aspectRatio: `${gridX} / ${gridY}` // 전체 비율 유지
                }}
            >
                {cells.map((cell) => (
                    <div key={cell.id} className="relative bg-white w-full h-full overflow-hidden">
                        {cell.photo ? (
                            <PhotoCell
                                id={cell.id}
                                photo={cell.photo}
                                projectId={board.project}
                                disabled={true}
                            />
                        ) : (
                            <div className="w-full h-full bg-slate-50 flex items-center justify-center">
                                <span className="text-gray-200 text-xs">빈 셀</span>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            <div className="mt-2 text-right">
                <span className="text-xs text-slate-400">
                    {gridX}x{gridY} 레이아웃
                </span>
            </div>
        </div>
    );
}
